const dictionary = {
    "zhCN":{
        "你好": "你好"
    },
    "enUS":{
        "你好": "Hello"
    }
};
export default dictionary;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/dictionary.js